import baseAPI from "../app/baseAPI";

export const QuoteReducer = baseAPI.injectEndpoints({
  endpoints(builder) {
    return {
      // 13. Save Quote
      sendQuoteDetails: builder.mutation({
        query(params) {
          return {
            url: `http://localhost:8080/quotes/create`,
            method: "POST",
            token: true,
            body: {
              ...params.paramsData, // Includes items and all relevant data
            },
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),
      
      // 12. Quote Calculation (Get Quote Summary)
      getQuoteSummary: builder.query({
        query(quoteId) {
          return {
            url: `http://localhost:8080/quotes/${quoteId}/summary`,
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // 14. Add Items to Quote (Add items when creating/updating a quote)
      addItemsToQuote: builder.mutation({
        query(params) {
          return {
            url: `http://localhost:8080/quotes/${params.quoteId}/items`,  // Placeholder endpoint for adding items
            method: "PATCH",
            token: true,
            body: {
              items: params.items,
            },
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // 15. View List of Quotations Made
      getAllQuotesByPlumber: builder.query({
        query(plumberId) {
          return {
            url: `http://localhost:8080/quotes/plumber/${plumberId}`,
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // Optionally, you may want to check for quotes by homeowner status
      getQuotesByHomeownerStatus: builder.query({
        query(homeownerId) {
          return {
            url: `http://localhost:8080/quotes/homeowner/${homeownerId}/status`,
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // 16. Revised Quote Details (NEW)
      sendRevisedQuoteDetails: builder.mutation({
        query(params) {
          return {
            url: `http://localhost:8080/quotes/revised`,
            method: "POST",
            token: true,
            body: {
              ...params.paramsData, // Include revised quote details
            },
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),
    };
  },
});

export const {
  useSendQuoteDetailsMutation,
  useGetQuoteSummaryQuery,
  useAddItemsToQuoteMutation,
  useGetAllQuotesByPlumberQuery,
  useGetQuotesByHomeownerStatusQuery,
  useSendRevisedQuoteDetailsMutation,  // Added the revised mutation hook
} = QuoteReducer;
